/**
 * When the phone bottom tab bar should stand down.
 * Guest landing full-screen has no ballot yet; post-auth name/address signup
 * also has none until the address is submitted (``initialSetupComplete``).
 */
export function shouldHideMobileTabBar(opts: {
  landingFullScreen: boolean;
  isAuthenticated: boolean;
  initialSetupComplete?: boolean;
}): boolean {
  if (opts.landingFullScreen) return true;
  // Signup modal: authenticated but address not saved yet — no ballot to preview.
  if (opts.isAuthenticated && !opts.initialSetupComplete) return true;
  return false;
}
